"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const webrtc_adapter_1 = require("webrtc-adapter");
exports.webRTCAdapter = webrtc_adapter_1.default;
